import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2
} from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { ProductsConfigService } from '@approot/services';
import { Utilities } from '@approot/utilities';

@Component({
  selector: 'app-options-portfolio-spots',
  templateUrl: './options-portfolio-spots.component.html',
  styleUrls: ['./options-portfolio-spots.component.scss']
})
export class OptionsPortfolioSpotsComponent implements OnInit {
  @Input() isOpened: boolean;
  @Input() legForm: FormGroup;
  @Output() optionsPortfolioSpotsOpenChanged = new EventEmitter();
  @Output() requestLatestSpot = new EventEmitter<{
    control: AbstractControl;
    cross: string;
  }>();
  currencyPairs: string[] = [];
  constructor(
    private renderer: Renderer2,
    private productsConfigService: ProductsConfigService
  ) {}

  ngOnInit(): void {
    if (this.legForm)
      this.currencyPairs = (
        this.legForm.get('optionsPortfolioSpots') as FormArray
      ).value.map(spot => Object.keys(spot)[0]); // get all the currency Pairs
  }

  textboxChange(element) {
    this.renderer.setStyle(element, 'color', Utilities.orangeTextColor);
  }

  spotBlur(element, item: FormGroup, cross: string) {
    // when bluring a text box convert the attribute changed into its formatted version that depends on the
    // cross if possible
    const control = item.get(cross);
    if (control.value) {
      control.setValue(
        this.productsConfigService.crossDecimalFormatter(control.value, cross)
      );
    } else {
      // on blur and no value set the spot to the latest spot
      this.requestLatestSpot.emit({ control, cross });
      // remove the colour of the textbox
      this.renderer.setStyle(element, 'color', Utilities.whiteTextColor);
    }
  }

  modalChanged(val: boolean) {
    this.optionsPortfolioSpotsOpenChanged.emit(val);
  }

  get portfolioSpots() {
    return (this.legForm.get('optionsPortfolioSpots') as FormArray)
      .controls as FormGroup[];
  }
}
